import { Box, styled } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
});
